import React from "react";

import { Box, Text as MantineText, TextProps, BoxProps } from "@mantine/core";

export const Page = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: BoxProps["style"];
}): JSX.Element => {
  return <Box style={{ border: "1px solid #000", ...style }}>{children}</Box>;
};
export const View = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: BoxProps["style"];
}): JSX.Element => {
  return <Box style={style}>{children}</Box>;
};
export const Text = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: TextProps["style"];
}): JSX.Element => {
  return (
    <MantineText style={{ fontFamily: "inherit", fontSize: "inherit", ...style }}>
      {children}
    </MantineText>
  );
};
